var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 65,
    height: 65,
    rx: 12,
    fill: "#EEFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3611 27.7605L30.1562 35.1069C31.8414 36.3708 34.1586 36.3708 35.8438 35.1069L45.6389 27.7604M31.4655 19.1338L20.4065 25.2777C19.4034 25.835 18.7812 26.8923 18.7812 28.0398V40.3993C18.7812 42.1444 20.1959 43.5591 21.941 43.5591H44.059C45.8041 43.5591 47.2188 42.1444 47.2188 40.3993V28.0398C47.2188 26.8923 46.5966 25.835 45.5935 25.2777L34.5345 19.1338C33.5802 18.6036 32.4198 18.6036 31.4655 19.1338Z",
    stroke: "#54D4BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcons);
export default __webpack_public_path__ + "static/media/Featured Icons.304dd765d382c551fe88af98f41c7ac7.svg";
export { ForwardRef as ReactComponent };